__turbopack_context__.v({
  "container": "M0a3na_container",
  "infoIcon": "M0a3na_infoIcon",
});
